import React from "react";
import axios from "axios";

import { Grid ,Form, Input, TextArea, Button, Select , Divider,Header,Icon ,Segment,Step,Dropdown,Message,MessageHeader, MessageContent,} from "semantic-ui-react";
import "antd/dist/antd.css";
import "../sidemenu.css";
import "../report.css";

import { reactLocalStorage } from "reactjs-localstorage";
import "react-notifications-component/dist/theme.css";
import "semantic-ui-css/semantic.min.css";
import "@brainhubeu/react-carousel/lib/style.css";
import i18n from "../i18n";
import { connect } from "react-redux";
import Menutest from "./menu.js";
import { SemanticToastContainer, toast } from "react-semantic-toasts";
import "react-semantic-toasts/styles/react-semantic-alert.css";
import { Link } from "react-router-dom";
import { selectedlanguage } from "../actions";
import Modal from "react-modal";
import { API_BASE_URL } from "../utils/endpoints";


class MigrationData extends React.Component {
  constructor() {
    super();

    this.state = {

     showFirstSection:true,
     showSecondSection:false,
     showThirdSection:false,

      password: "",
      username: "",
      errorResponse:"",
      selectedValue: [],
      isSubmitting: false,
      otp:"",
      lng: "en",
   
      get_error:"",
      showError:false,
      showOTP:false,
      otp_token:"",
      taskValue: [],
      taskStatus:[],
      migrationCompleted:false,
      selectedValues:[],
      currentUserId:"",
      oldUserId:"",
      disabledButton: null, // Tracks which button is disabled
    };

  }

  changeUserName = event => {
    this.setState({ username: event.target.value ,showOTP:false,otp:""});
  };
  changePassword = event => {
    this.setState({ password: event.target.value,showOTP:false,otp:"" });
  };

  SubmitPassword = event => {
    this.setState({ showError: false ,otp_token:""}); 
    event.preventDefault();
    var x=this;
    if (
  
      this.state.password.length === 0 ||
      this.state.username.length === 0
    ) {
      toast({
        type: "error",
        title: i18n.t("error.label"),
        description: i18n.t("Please_fill_all_fields.label"),
        animation: "bounce",
        time: 5000
      });
    } 
    
     else {
        this.setState({ isSubmitting: true ,showError: false,otp_token:""}); // Show overlay

        var ip = API_BASE_URL;
        var s2 = "localhost:3000";
        var apiBaseUrl;
        if (ip.includes(s2)) {
          
          apiBaseUrl =
            API_BASE_URL + "/core/old-user/rest/auth/login";
        } else {
          apiBaseUrl =
            "https://zsms.jo.zain.com/core/user/rest/auth/login";
         
        }
        var data = {};
     
        var headers = {
          "content-type": "application/json",
          username: this.state.username,
          password: this.state.password,
        };
        axios
  .post(apiBaseUrl, data, { headers: headers })
  .then((response) => { // Use arrow function here
    console.log(response.data.accessToken);
    if (response.status === 200) {
      if (response.data.accessToken !== null) {
       
        this.setState({ showError: false, showOTP: true, isSubmitting: false,otp_token: response.data.accessToken});
          reactLocalStorage.set( "old_accessToken",response.data.accessToken);

        x.callOTP();

        
        
      }

      if (response.data.accessToken===null) { // Handling null accessToken case

        this.setState({
          get_error: response.data.failedLoginReason,
          showError: true,
          showOTP: false,
          isSubmitting: false
        });

      
      }
    } else if (response.status === 204) {
      this.setState({
        get_error: response.data.failedLoginReason,
        showError: true,
        showOTP: false,
        isSubmitting: false
      });

     
    } else {
      this.setState({
        get_error: response.data.failedLoginReason,
        showError: true,
        showOTP: false,
        isSubmitting: false
      });

      toast({
        type: "error",
        title: i18n.t("error.label"),
        description: i18n.t("Something_wrong.label"),
        animation: "bounce",
        time: 5000
      });
    }
  })
  .catch((error) => {
    console.error("Login error:", error);
    this.setState({ isSubmitting: false }); // Ensure overlay is removed even on failure
  });

      
      
    }
  };


callOTP = () =>{
   

    var x=this;
   
      

        var ip = API_BASE_URL;
        var s2 = "localhost:3000";
        var apiBaseUrl;
        if (ip.includes(s2)) {
          
          apiBaseUrl =
            API_BASE_URL + "/core/old-user/rest/auth/otp/login";
        } else {
          apiBaseUrl =
            "https://zsms.jo.zain.com/core/user/rest/auth/otp/login";
         
        }
        var data = {};
     
        var headers = {
          "content-type": "application/json",
          "token": reactLocalStorage.get("old_accessToken")
        };
        axios
  .post(apiBaseUrl, data, { headers: headers })
  .then((response) => { // Use arrow function here
  
    if (response.status === 200) {
      
    } else if (response.status === 204) {
      this.setState({
        get_error: response.data.failedLoginReason,
        showError: true,
        showOTP: false,
        isSubmitting: false
      });

     
    } else {
      this.setState({
        get_error: response.data.failedLoginReason,
        showError: true,
        showOTP: false,
        isSubmitting: false
      });

      toast({
        type: "error",
        title: i18n.t("error.label"),
        description: i18n.t("Something_wrong.label"),
        animation: "bounce",
        time: 5000
      });
    }
  })
  .catch((error) => {
    console.error("Login error:", error);
    this.setState({ isSubmitting: false }); // Ensure overlay is removed even on failure
  });

      
    
      
  };



  handleChange = (e, { value }) => {
    this.setState({ selectedValue: value });
  };


  changeOTP = event => {
    this.setState({ otp: event.target.value });
  };


SubmitOTP = event => {
    this.setState({ showError: false, }); 
    event.preventDefault();
    var x=this;
    if (
  
      this.state.otp.length === 0 
    ) {
      toast({
        type: "error",
        title: i18n.t("error.label"),
        description: i18n.t("Please_fill_all_fields.label"),
        animation: "bounce",
        time: 5000
      });
    } 
    
     else {
        this.setState({ isSubmitting: true,showError: false, }); // Show overlay

        var ip = API_BASE_URL;
        var s2 = "localhost:3000";
        var apiBaseUrl;
        if (ip.includes(s2)) {
          
          apiBaseUrl =
            API_BASE_URL + "/core/old-user/rest/auth/verify/login";
        } else {
          apiBaseUrl =
            "https://zsms.jo.zain.com/core/user/rest/auth/verify/login";
        }
        var data = {
            otp_code:this.state.otp
        };
        var headers = {
          "content-type": "application/json",
          token:  reactLocalStorage.get("old_accessToken")
          
        };


        axios
        .post(apiBaseUrl, data, { headers: headers })
        .then((response) => {
          
          if (response.status === 200) {
            if (response.data.status === "sucess") {
              if (response.data.result.message) {
                toast({
                  type: "success",
                  title: i18n.t("success.label"),
                  description: response.data.result.message,
                  animation: "bounce",
                  time: 5000
                });
              }
              this.setState({ showError: false, showOTP: true, isSubmitting: false ,showFirstSection:false, showSecondSection:true,showThirdSection:false});
              this.GetOldUserId();
              
            }
      
            if (response.data.status === "failed") { // Handling null accessToken case
              console.log("haya ali ");
              console.log(response.data.accessToken);
              this.setState({
                get_error: response.data.accessToken,
                showError: true,
                isSubmitting: false
              });
      
              toast({
                type: "failed",
                title: i18n.t("failed.label"),
                description: response.data.accessToken,
                animation: "bounce",
                time: 5000
              });
            }
          } else if (response.status === 204) {
            this.setState({
              get_error: response.data.accessToken,
              showError: true,
            
              isSubmitting: false
            });
      
            toast({
              type: "error",
              title: i18n.t("error.label"),
              description: i18n.t("Something_wrong.label"),
              animation: "bounce",
              time: 5000
            });
          } else {
            this.setState({
              get_error: response.data.result.message,
              showError: true,
            
              isSubmitting: false
            });
      
            toast({
              type: "error",
              title: i18n.t("error.label"),
              description: i18n.t("Something_wrong.label"),
              animation: "bounce",
              time: 5000
            });
          }
        })
        .catch((error) => {
          console.error("Login error:", error);
          this.setState({ isSubmitting: false }); // Ensure overlay is removed even on failure
        });
      

    }
  };


  GetOldUserId = event => {
    this.setState({ showError: false, }); 
    var x=this;
   
        this.setState({ isSubmitting: true,showError: false, }); // Show overlay

        var ip = API_BASE_URL;
        var s2 = "localhost:3000";
        var apiBaseUrl;
        if (ip.includes(s2)) {
          
          apiBaseUrl =
            API_BASE_URL + "/core/old-user/rest/user/loadbytokken";
        } else {
          apiBaseUrl =
            "https://zsms.jo.zain.com/core/user/rest/user/loadbytokken";
        }
        var data = {};
       
        var headers = {
          "content-type": "application/json",
          "tokken":   reactLocalStorage.get("old_accessToken"),
          
          
        };


        axios
        .get(apiBaseUrl, { headers: headers })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.status === "success") {

              reactLocalStorage.set( "old_userID",response.data.result.id,);
            
              this.setState({ oldUserId:response.data.result.id,showError: false, showOTP: false, isSubmitting: false});
              this.SubmitGetTasks();
           
            }
      
            if (response.data.status === "failed") { // Handling null accessToken case
              this.setState({
                get_error: response.data.result.ErrorResutl,
                showError: true,
                isSubmitting: false
              });
      
              toast({
                type: "failed",
                title: i18n.t("failed.label"),
                description: response.data.result.ErrorResutl,
                animation: "bounce",
                time: 5000
              });
            }
          } else if (response.status === 204) {
            this.setState({
              get_error: response.data.result.ErrorResutl,
              showError: true,
            
              isSubmitting: false
            });
      
            toast({
              type: "error",
              title: i18n.t("error.label"),
              description: i18n.t("Something_wrong.label"),
              animation: "bounce",
              time: 5000
            });
          } else {
            this.setState({
              get_error: response.data.result.ErrorDescription,
              showError: true,
            
              isSubmitting: false
            });
      
            toast({
              type: "error",
              title: i18n.t("error.label"),
              description: i18n.t("Something_wrong.label"),
              animation: "bounce",
              time: 5000
            });
          }
        })
        .catch((error) => {
          console.error("Login error:", error);
          this.setState({ isSubmitting: false }); // Ensure overlay is removed even on failure
        });
      

    
  };


  SubmitGetTasks = event => {
    this.setState({ showError: false, }); 
    var x=this;
    if (
  
      this.state.otp.length === 0 
    ) {
      toast({
        type: "error",
        title: i18n.t("error.label"),
        description: i18n.t("Please_fill_all_fields.label"),
        animation: "bounce",
        time: 5000
      });
    } 
    
     else {
        this.setState({ isSubmitting: true,showError: false, }); // Show overlay

        var ip = API_BASE_URL;
        var s2 = "localhost:3000";
        var apiBaseUrl;
        if (ip.includes(s2)) {
          
          apiBaseUrl =
            API_BASE_URL + "/core/user/rest/migrations/users/old-sub-admins";
        } else {
          apiBaseUrl =
            API_BASE_URL + "/core/user/rest/migrations/users/old-sub-admins";
        }
        var data = {};
       
        var headers = {
          "content-type": "application/json",
          "New-Admin-Token":   reactLocalStorage.get("accessToken"),
          "Old-Admin-Token":  reactLocalStorage.get("old_accessToken"),// this from new form login in migration screen
          
        };


        axios
        .get(apiBaseUrl, { headers: headers })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.status === "success") {

                var newArr =[]
                var i;
                  for (i = 0; i < response.data.result.result.length; i++) {
          
           if(response.data.result.result[i].migratedToNewCorp===false){
             newArr.push({
                      key: response.data.result.result[i].id,
                      text: response.data.result.result[i].userName,
                      value: response.data.result.result[i].id, // Ensure value is present

                     
                    });
                }
                   
                  }
            
              this.setState({ showError: false, showOTP: false, isSubmitting: false,taskValue: newArr});
              console.log(this.state.taskValue);
            }
      
            if (response.data.status === "failed") { // Handling null accessToken case
              this.setState({
                get_error: response.data.result.ErrorDescription,
                showError: true,
                isSubmitting: false
              });
      
              toast({
                type: "failed",
                title: i18n.t("failed.label"),
                description: response.data.result.ErrorDescription,
                animation: "bounce",
                time: 5000
              });
            }
          } else if (response.status === 204) {
            this.setState({
              get_error: response.data.result.ErrorDescription,
              showError: true,
            
              isSubmitting: false
            });
      
            toast({
              type: "error",
              title: i18n.t("error.label"),
              description: i18n.t("Something_wrong.label"),
              animation: "bounce",
              time: 5000
            });
          } else {
            this.setState({
              get_error: response.data.result.ErrorDescription,
              showError: true,
            
              isSubmitting: false
            });
      
            toast({
              type: "error",
              title: i18n.t("error.label"),
              description: i18n.t("Something_wrong.label"),
              animation: "bounce",
              time: 5000
            });
          }
        })
        .catch((error) => {
          console.error("Login error:", error);
          this.setState({ isSubmitting: false }); // Ensure overlay is removed even on failure
        });
      

    }
  };


  StartMigration = event => {

    
 if(this.state.migrationCompleted===true){
 //this is line before 20 March 2025
   // this.setState({ showError: true, get_error:"you can't use migration option"}); 

  //the following after 20 March 2025


 if(this.state.selectedValues.length===0){
        this.setState({ showError: true, get_error:"need to select task"}); 
    }
    if(this.state.selectedValues.length!=0){
    
        var x=this;
        this.setState({ isSubmitting:true,showError: false,showSecondSection:false, showThirdSection:true}); // Show overlay
            var ip = API_BASE_URL;
            var s2 = "localhost:3000";
            var apiBaseUrl;
            if (ip.includes(s2)) {
            
              apiBaseUrl =
                API_BASE_URL + "/core/user/rest/migrations/old-sub-admins";
            } else {
              apiBaseUrl =
                API_BASE_URL + "/core/user/rest/migrations/old-sub-admins";
            }
            var data = {
              
                "subAdminsIds":this.state.selectedValues
                  };
            var headers = {
                "content-type": "application/json",
                "New-Admin-Token":   reactLocalStorage.get("accessToken"),// this from current login in main system
                
              };
    
    
            axios
            .post(apiBaseUrl, data, { headers: headers })
            .then((response) => {
              
              if (response.status === 200) {
                if (response.data.status === "success") {
                  if (response.data.result.message) {
                    toast({
                      type: "success",
                      title: i18n.t("success.label"),
                      description: response.data.result.result,
                      animation: "bounce",
                      time: 5000
                    });
                  }
                  this.setState({ showError: false, showOTP: false, isSubmitting: true ,showFirstSection:false, showSecondSection:false,showThirdSection:false});
                /*  setTimeout(() => {
                    this.GetTasksStatusOld();
                  }, 30000); */
                this.GetTasksStatusOld();
                }
          
                if (response.data.status === "failed") { // Handling null accessToken case
                  this.setState({
                    get_error: response.data.result.ErrorDescription,
                    showError: true,
                    isSubmitting: false
                  });
          
                  toast({
                    type: "failed",
                    title: i18n.t("failed.label"),
                    description: response.data.result.ErrorDescription,
                    animation: "bounce",
                    time: 5000
                  });
                }
              } else if (response.status === 204) {
                this.setState({
                  get_error: response.data.result.ErrorDescription,
                  showError: true,
                
                  isSubmitting: false
                });
          
                toast({
                  type: "error",
                  title: i18n.t("error.label"),
                  description: i18n.t("Something_wrong.label"),
                  animation: "bounce",
                  time: 5000
                });
              } else {
                this.setState({
                  get_error: response.data.result.ErrorDescription,
                  showError: true,
                
                  isSubmitting: false
                });
          
                toast({
                  type: "error",
                  title: i18n.t("error.label"),
                  description: i18n.t("Something_wrong.label"),
                  animation: "bounce",
                  time: 5000
                });
              }
            })
            .catch((error) => {
              console.error("Login error:", error);
              this.setState({ isSubmitting: false }); // Ensure overlay is removed even on failure
            });
        
        }

    }



  if(this.state.migrationCompleted===false){

    if(this.state.selectedValues.length===0){
        this.setState({ showError: true, get_error:"need to select task"}); 
    }
    if(this.state.selectedValues.length!=0){
    
        var x=this;
        this.setState({ isSubmitting:true,showError: false,showSecondSection:false, showThirdSection:true}); // Show overlay
            var ip = API_BASE_URL;
            var s2 = "localhost:3000";
            var apiBaseUrl;
            if (ip.includes(s2)) {
              
              apiBaseUrl =
                API_BASE_URL + "/core/user/rest/migrations/start";
            } else {
              apiBaseUrl =
                API_BASE_URL + "/core/user/rest/migrations/start";
            }
            var data = {
                "oldCorpUserId":this.state.oldUserId,
                "newCorpUserId":this.state.currentUserId,
                "subAdminsIds":this.state.selectedValues
                  };
            var headers = {
                "content-type": "application/json",
                "New-Admin-Token":   reactLocalStorage.get("accessToken"),// this from current login in main system
                "Old-Admin-Token":  reactLocalStorage.get("old_accessToken"),// this from new form login in migration screen from old system to new
                
              };
    
    
            axios
            .post(apiBaseUrl, data, { headers: headers })
            .then((response) => {
              
              if (response.status === 200) {
                if (response.data.status === "success") {
                  if (response.data.result.message) {
                    toast({
                      type: "success",
                      title: i18n.t("success.label"),
                      description: response.data.result.result,
                      animation: "bounce",
                      time: 5000
                    });
                  }
                  this.setState({ showError: false, showOTP: false, isSubmitting: true ,showFirstSection:false, showSecondSection:false,showThirdSection:false});
                /*  setTimeout(() => {
                    this.GetTasksStatus();
                  }, 30000); */
                this.GetTasksStatus();
                }
          
                if (response.data.status === "failed") { // Handling null accessToken case
                  this.setState({
                    get_error: response.data.result.ErrorDescription,
                    showError: true,
                    isSubmitting: false
                  });
          
                  toast({
                    type: "failed",
                    title: i18n.t("failed.label"),
                    description: response.data.result.ErrorDescription,
                    animation: "bounce",
                    time: 5000
                  });
                }
              } else if (response.status === 204) {
                this.setState({
                  get_error: response.data.result.ErrorDescription,
                  showError: true,
                
                  isSubmitting: false
                });
          
                toast({
                  type: "error",
                  title: i18n.t("error.label"),
                  description: i18n.t("Something_wrong.label"),
                  animation: "bounce",
                  time: 5000
                });
              } else {
                this.setState({
                  get_error: response.data.result.ErrorDescription,
                  showError: true,
                
                  isSubmitting: false
                });
          
                toast({
                  type: "error",
                  title: i18n.t("error.label"),
                  description: i18n.t("Something_wrong.label"),
                  animation: "bounce",
                  time: 5000
                });
              }
            })
            .catch((error) => {
              console.error("Login error:", error);
              this.setState({ isSubmitting: false }); // Ensure overlay is removed even on failure
            });
          
    
        





        }
}

    
    

};

CancelMigration =event =>{
    this.setState({showFirstSection:true, showSecondSection:false ,showThirdSection:false,showOTP:false,  password: "", username: "",otp:"",showError:false })
}
    
CloseMigration =event =>{
    this.setState({showFirstSection:true, showSecondSection:false ,showThirdSection:false,showOTP:false,  password: "", username: "",otp:"",showError:false })
}



/*GetTasksStatus = event => {
    this.setState({ showError: false, }); 
    var x=this;
   
        this.setState({ isSubmitting: true,showError: false, }); // Show overlay

        var ip = API_BASE_URL;
        var s2 = "localhost:3000";
        var apiBaseUrl;
        if (ip.includes(s2)) {
          
          apiBaseUrl =
            API_BASE_URL + "/core/user/rest/migrations/tasks-status";
        } else {
          apiBaseUrl =
            API_BASE_URL + "/core/user/rest/migrations/tasks-status";
        }
        var data = {};
       
        var headers = {
          "content-type": "application/json",
          "New-Admin-Token":   reactLocalStorage.get("accessToken"),
          
        };


        axios
        .get(apiBaseUrl, { headers: headers })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.status === "success") {

                var newArr =[]
                var i;
                  for (i = 0; i < response.data.result.result.length; i++) {
          
                    newArr.push({
                      key: response.data.result.result[i].taskName,
                      text: response.data.result.result[i].status,
                      value: response.data.result.result[i].sequence, // Ensure value is present

                     
                    });
                  }
            
              this.setState({ showError: false, showOTP: false, isSubmitting: false,taskStatus: newArr,showThirdSection:true});
              console.log(this.state.taskStatus);
            }
      
            if (response.data.status === "failed") { // Handling null accessToken case
              this.setState({
                get_error: response.data.result.ErrorDescription,
                showError: true,
                isSubmitting: false
              });
      
              toast({
                type: "failed",
                title: i18n.t("failed.label"),
                description: response.data.result.ErrorDescription,
                animation: "bounce",
                time: 5000
              });
            }
          } else if (response.status === 204) {
            this.setState({
              get_error: response.data.result.ErrorDescription,
              showError: true,
            
              isSubmitting: false
            });
      
            toast({
              type: "error",
              title: i18n.t("error.label"),
              description: i18n.t("Something_wrong.label"),
              animation: "bounce",
              time: 5000
            });
          } else {
            this.setState({
              get_error: response.data.result.ErrorDescription,
              showError: true,
            
              isSubmitting: false
            });
      
            toast({
              type: "error",
              title: i18n.t("error.label"),
              description: i18n.t("Something_wrong.label"),
              animation: "bounce",
              time: 5000
            });
          }
        })
        .catch((error) => {
          console.error("Login error:", error);
          this.setState({ isSubmitting: false }); // Ensure overlay is removed even on failure
        });
      

    
  };*/

GetTasksStatus = (retryCount = 0, maxRetries = 5) => {
    this.setState({ showError: false });

    var apiBaseUrl =
        API_BASE_URL.includes("localhost:3000")
            ? API_BASE_URL + "/core/user/rest/migrations/tasks-status"
            : API_BASE_URL + "/core/user/rest/migrations/tasks-status";

    var headers = {
        "content-type": "application/json",
        "New-Admin-Token": reactLocalStorage.get("accessToken"),
    };

    axios
        .get(apiBaseUrl, { headers: headers })
        .then((response) => {
            if (response.status === 200) {
                if (response.data.status === "success") {
                    let newArr = response.data.result.result.map(item => ({
                        key: item.taskName,
                        text: item.status,
                        value: item.sequence,
                    }));

                    this.setState({
                        showError: false,
                        showOTP: false,
                        isSubmitting: false,
                        taskStatus: newArr,
                        showThirdSection: true,
                    });

                    console.log(this.state.taskStatus);
                } else {
                    this.handleFailure(response, retryCount, maxRetries);
                }
            } else {
                this.handleFailure(response, retryCount, maxRetries);
            }
        })
        .catch((error) => {
            console.error("API error:", error);
            this.handleFailure(null, retryCount, maxRetries);
        });
};


GetTasksStatusOld = (retryCount = 0, maxRetries = 5) => {
    this.setState({ showError: false });
 
    var apiBaseUrl =
        API_BASE_URL.includes("localhost:3000")
            ? API_BASE_URL + "/core/user/rest/migrations/sub-admins-tasks-status/"
            : API_BASE_URL + "/core/user/rest/migrations/sub-admins-tasks-status/";

    var headers = {
        "content-type": "application/json",
        "New-Admin-Token": reactLocalStorage.get("accessToken"),
    };

    axios
        .get(apiBaseUrl, { headers: headers })
        .then((response) => {
            if (response.status === 200) {
                if (response.data.status === "success") {
                    let newArr = response.data.result.result.map(item => ({
                        key: item.taskName,
                        text: item.status,
                        value: item.sequence,
                    }));

                    this.setState({
                        showError: false,
                        showOTP: false,
                        isSubmitting: false,
                        taskStatus: newArr,
                        showThirdSection: true,
                    });

                    console.log(this.state.taskStatus);
                } else {
                    this.handleFailure(response, retryCount, maxRetries);
                }
            } else {
                this.handleFailure(response, retryCount, maxRetries);
            }
        })
        .catch((error) => {
            console.error("API error:", error);
            this.handleFailure(null, retryCount, maxRetries);
        });
};

handleFailure = (response, retryCount, maxRetries) => {
    if (retryCount < maxRetries) {
        console.log(`Retrying (${retryCount + 1}/${maxRetries})...`);
        setTimeout(() => this.GetTasksStatus(retryCount + 1, maxRetries), 20000);
    } else {
        this.setState({ isSubmitting: false, showError: true });

        toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Something_wrong.label"),
            animation: "bounce",
            time: 5000,
        });
    }
};


  onSelectTask = (e, { value }) => {
    console.log("Selected Values:", value); // Check that it's an array
    this.setState({ selectedValues: value || [] }); // Default to empty array if undefined
  };


  componentDidMount() {
    reactLocalStorage.get("authenticated");
    reactLocalStorage.get("accessToken");

    var lang = i18n.language;
    if (lang === "ar") {
      this.setState({isArabic:true})
      document.querySelector(".main_div_loading").style = "direction:rtl";
      document.querySelector(".ant-menu").style = "text-align:right";
      document.querySelector(".blue_color").style =
      "direction: rtl;float: right;";
        document.querySelector(".fixed_profile").style = "margin-right: 0% !important;";
    }

    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl = API_BASE_URL + "/core/user/rest/user/loadbytokken";
    } else {
      apiBaseUrl = API_BASE_URL + "/core/user/rest/user/loadbytokken";
    }

    var headers = { "Content-Type": "application/json", tokken: token };
    axios.get(apiBaseUrl, { headers: headers }).then(res => {
      if (res.data.result.ErrorResutl) {
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: res.data.result.ErrorResutl,
          animation: "bounce",
          time: 5000
        });
        window.location = "/app";
      } else {
        this.setState({
            migrationCompleted:res.data.result.migrationCompleted ,
            currentUserId:res.data.result.id 

        });
      

     
      
    
      }
    });
   
    var lang = i18n.language;
    if (lang === "ar") {
    
        document.querySelector(".blue_color").style =
        "text-align:right;width: 20%;white-space: pre;";
   
    }
  }


 
  back = () => {
    window.location = "dashboard";
  };

  render() {

    return (
      <div className="big_div">
        <Menutest />
        <div className="actionMenu" >
          <Grid columns={2} divided className="fixed_profile">
            <Grid.Row stretched className='fixed_header'>
              <Grid.Column className="grid_logo ">
              
                <Segment>
                      <h3 className="text_style blue_color">
                        {reactLocalStorage.get("lang")==="ar"?(
                      <img
                        src={require("../pictures/ArabicHedar.png")}
                        style={{width:'100% !important',height:'117px',marginTop:'8px',marginRight:'-13px'}}
                       className="himage"
                      />
                        ):(<img
                          src={require("../pictures/EnglishHedar.png")}
                          style={{width:'100% !important',height:'117px',marginLeft:'-13px',marginTop:'8px'}}
                         className="himage"
                        />)}
                      </h3>
                    </Segment>
              </Grid.Column>
            </Grid.Row>
          </Grid>
         
          <br></br><br></br><br></br><br></br>
      <div className="container_cards"  style={{paddingRight:this.state.isArabic? '':'20px'}}>

      <div >
      <br></br>
      {this.state.isSubmitting !=true?null: (
        <div className="overlay">
            <Segment raised textAlign="center" className="loading-segment" >
            <Icon name="spinner" size="large" loading />
            <p style={{marginTop:"20%"}}>Submitting...</p>
            </Segment>
        </div>
        )}


{/*the following is first Part to login in old System  */}
{this.state.showFirstSection== false?null: <Segment color='black' style={{padding:'20px', minHeight:'200px'}} >
              <Form style={{padding:'20px'}}>
                  <Divider horizontal>
                    <Header as='h2'> <Icon name='unlock alternate' color="black" />  {reactLocalStorage.get('lang')==='ar' ? 'تسجيل الدخول للمسؤول في النظام القديم':'Admin login in old system' } </Header>
                  </Divider>
                <br></br><br/>
              
                <Form.Group widths='equal'  style={{ textAlign: reactLocalStorage.get('lang')==='ar'  ? "right" : "left"}}  > 
                    <Form.Input label="Username" 
                        onChange={this.changeUserName}
                        type="text"
                        id="defaultFormCardNameEx"
                        name="old_password"
                        width={6}
                            />
                    <Form.Input label= "Password"
                    onChange={this.changePassword}
                    type="password"
                    id="defaultFormCardNameEx"
                    name="new_password" width={6}/>

                </Form.Group>

                <Button content={i18n.t("Submit.label")} basic onClick={this.SubmitPassword} floated={reactLocalStorage.get('lang')==='ar'?'left' :' right'}/>
                    <br></br> <br></br>
                 {this.state.showOTP &&(
                        <Form.Group widths='equal'  style={{ textAlign: reactLocalStorage.get('lang')==='ar'  ? "right" : "left"}}  > 
                        <Form.Input label="Verify OTP" 
                            onChange={this.changeOTP}
                            type="otp"
                            id="defaultFormCardNameEx"
                            name="otp"
                            width={6}
                                />
                    </Form.Group>
                    )}
                  {this.state.showOTP &&(
                  <Button content= "Verify" basic onClick={this.SubmitOTP} floated={reactLocalStorage.get('lang')==='ar'?'left' :' right'}/>

                  )}
                  <br></br>
                  <br></br>
                   {/* Error message container */}
                  {this.state.showError !=true?null: (
                <Message negative className="error-container">
                <Icon name="exclamation circle" />
                {this.state.get_error}
                </Message>
            
          )}
                 
       
                
                   <br></br>
                   <br></br>
                   <br></br>
              </Form>
              </Segment>}
             



{/*the following is Second  Part to select task to migration */}
{this.state.showSecondSection== false?null:
 <Segment color='black' style={{padding:'20px', minHeight:'200px'}} >
                <Form style={{padding:'20px'}}>
                    <Divider horizontal>
                    <Header as='h2'> <Icon name='database' color="black" />  {reactLocalStorage.get('lang')==='ar' ? 'مهام الترحيل':'Migration Tasks' } </Header>
                    </Divider>
                    <br></br><br/>
                    <Header as='h6'>  {reactLocalStorage.get('lang')==='ar' ? 'الرجاء تحديد المهمة التي تريد نقلها':'Please select the data that you want to migrate' } </Header>

                    <Form.Group widths='equal'  style={{ textAlign: reactLocalStorage.get('lang')==='ar'  ? "right" : "left"}}  > 
                    <br/>

                    <Select
                    className="custom-dropdown" 
                        placeholder={i18n.t("select.label")}
                        search
                        multiple  // Enables multi-selection
                        selection
                        options={this.state.taskValue}
                        value={this.state.selectedValues || []}  // Ensure value is always an array
                        onChange={this.onSelectTask.bind(this)}
                        style={{ width: "100%" }}
                        />
                    </Form.Group>

                    <Button content= "Cancel Migration" basic onClick={this.CancelMigration} floated={reactLocalStorage.get('lang')==='ar'?'left' :' right'}/>
                    
                    <Button content= "Start Migration" basic onClick={this.StartMigration} floated={reactLocalStorage.get('lang')==='ar'?'left' :' right'}/>
                    
                    <br></br>
                    <br></br>
                    {/* Error message container */}
                    {this.state.showError !=true?null: (
                    <Message negative className="error-container">
                    <Icon name="exclamation circle" />
                    {this.state.get_error}
                    </Message>
            )}
               
                    <br></br>
                    <br></br>
                    <br></br>
                </Form>
              </Segment>}


{/*the following is third  Part to check process */}
   {this.state.showThirdSection== false?null: <Segment color='black' style={{padding:'20px', minHeight:'200px'}} >
                <Form style={{padding:'20px'}}>
                    <Divider horizontal>
                    <Header as='h2'> <Icon name='tasks' color="black" />  {reactLocalStorage.get('lang')==='ar' ? 'حالة البيانات':'Data Status' } </Header>
                    </Divider>
                    <br></br><br/>
                    {this.state.taskStatus.map((item, index) => (
                        <Message icon color="yellow" key={index}>
                          
                            <Message.Content>
                            <Message.Header>  {`${item.key}`}</Message.Header>
                             {item.text}
                            </Message.Content>
                        </Message>
                    ))}

    <Button content= "Close Migration" basic onClick={this.CloseMigration} floated={reactLocalStorage.get('lang')==='ar'?'left' :' right'}/>   
                    <br></br>
                    <br></br>
                    {/* Error message container */}
                    {this.state.showError !=true?null: (
                    <Message negative className="error-container">
                    <Icon name="exclamation circle" />
                    {this.state.get_error}
                    </Message>
            )}   
                    <br></br>
                    <br></br>
                    <br></br>
                </Form>
              </Segment>}
             
              
      </div>
                
                <SemanticToastContainer />
          
              </div>
            </div>
          </div>
        );
      }
      }
      const mapStateToProps = state => {
      return { ...state };
      };
      export default connect(
      mapStateToProps,
      { selectedlanguage }
      )(MigrationData);





       {/*   <Dropdown
                    placeholder="Select User"
                    fluid
                    multiple
                    selection
                    options={options}
                    value={this.state.selectedValue}
                    onChange={this.handleChange}
                    renderLabel={(label) => ({
                      
                        content: <span style={{ color: "black", fontWeight: "normal" }}>{label.text}</span>,
                        icon: "user",
                      })}
                      style={{ fontSize: "14px", color: "gray", fontWeight: "bold" }} // Dropdown text styling
                    />
                     <p>Selected IDs: {this.state.selectedValue.join(", ")}</p>*/}